var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetch } from '@mitchell/typescript.service.fetch';
import { HttpCacheType, HttpMethodType, HttpHeaderType, HttpContentType, EnvironmentService, handleResponseWithExplicitErrorMessage } from "../../common";
import { PhotoCaptureServiceHeader } from '../constants';
export class PhotoCaptureFoldersService {
    constructor(fetchWrapper = fetch) {
        this.fetchWrapper = fetchWrapper;
    }
    static generateRequestHeaders(contextId) {
        return {
            [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON,
            [HttpHeaderType.ACCEPT]: HttpContentType.APPLICATION_JSON,
            [HttpHeaderType.PRAGMA]: HttpCacheType.NO_CACHE,
            [HttpHeaderType.XMI_CALLER]: PhotoCaptureServiceHeader.applicationName,
            [HttpHeaderType.XMI_REQUEST_ID]: contextId
        };
    }
    static getRequest(uri, method, contextId) {
        return new Request(uri, {
            method: method,
            cache: HttpCacheType.NO_CACHE,
            headers: PhotoCaptureFoldersService.generateRequestHeaders(contextId)
        });
    }
    photoCaptureGetFolders(coCode, contextId) {
        return __awaiter(this, void 0, void 0, function* () {
            const uri = `${EnvironmentService.getEnvironment().apdApiGatewayRoot}photo-based-estimating-orch-api/v1/companies/${coCode}/folders`;
            const request = PhotoCaptureFoldersService.getRequest(uri, HttpMethodType.GET, contextId);
            return yield this.fetchWrapper(request).then(response => handleResponseWithExplicitErrorMessage(response)
                .then(resp => {
                return Promise.resolve(resp);
            })
                .catch(error => {
                return Promise.reject(JSON.parse(error));
            }));
        });
    }
}
//# sourceMappingURL=PhotoCaptureFoldersService.js.map